import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Phone } from "@phosphor-icons/react";
import { PHONE_DISPLAY, PHONE_TEL, IMAGES } from "@/lib/brand";

export const StickyNav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="sticky-nav"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 w-full z-50 transition-[background-color,border-color,padding] duration-500 border-b ${
        scrolled
          ? "bg-black/80 backdrop-blur-xl border-white/10 py-2"
          : "bg-transparent border-transparent py-4"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 group">
          <img
            src={IMAGES.logo}
            alt="Twizted Tow"
            className="h-11 md:h-14 w-auto transition-transform duration-500 group-hover:scale-105"
          />
          <span className="hidden sm:block font-display text-lg md:text-xl uppercase leading-none tracking-tight">
            Twizted<span className="text-[var(--tt-green)]">Tow</span>
          </span>
        </a>

        <a
          href={PHONE_TEL}
          data-testid="nav-call-button"
          className="group flex items-center gap-2 md:gap-3 bg-[var(--tt-green)] text-black font-display uppercase text-sm md:text-lg px-4 md:px-7 py-2.5 md:py-3 border-2 border-[var(--tt-green)] hover:bg-transparent hover:text-[var(--tt-green)] hover:shadow-[0_0_24px_rgba(57,255,20,0.45)] transition-[background-color,color,box-shadow] duration-300 tt-clip-card"
        >
          <Phone weight="fill" className="h-4 w-4 md:h-5 md:w-5 group-hover:animate-pulse" />
          <span className="tracking-tight">
            <span className="hidden md:inline">Call Now: </span>
            {PHONE_DISPLAY}
          </span>
        </a>
      </div>
    </motion.header>
  );
};
